(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-options"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const data = JSON.parse(document.querySelector('[data-product-variant-options]').textContent || '{}');
    const hiddenVariantIds = data.hidden_variant_ids;
    const productVariants = data.product_variants;

    const variantRadios = document.querySelectorAll('input[type="radio"]');
    const colorRadios = [...variantRadios].filter((radio) => radio.name === 'Colour');
    const sizeRadios = [...variantRadios].filter((radio) => radio.name === 'Size');

    const disabledAndCheckedRadio = (radio) => radio.checked && radio.classList.contains('disabled');
    const notDisabledRadio = (radio) => !radio.classList.contains('disabled');

    const updateOptionCountLabel = (optionCount, optionName) => {
      if (!optionCount || !optionName) return;

      const optionsCount = document.querySelector(`.options_count[option-name="${optionName}"]`);
      if (!optionsCount) return;

      const optionNameFormatted = (optionCount <= 1 ? optionName : optionName + 's').toLowerCase();
      optionsCount.textContent = `(${optionCount} ${optionNameFormatted})`;
    };

    const validateOptionCount = () => {
      if (sizeRadios.length > 0) {
        const notDisabledSizes = sizeRadios.filter(notDisabledRadio);
        updateOptionCountLabel(notDisabledSizes.length, 'Size');
      }

      if (colorRadios.length > 0) {
        const notDisabledColors = colorRadios.filter(notDisabledRadio);
        updateOptionCountLabel(notDisabledColors.length, 'Colour');
      }
    };

    const validateSelectedVariant = (event) => {
      if (!event.detail || !event.detail.variant) {
        validateOptionCount();
        return;
      }

      const selectedVariant = event.detail.variant;
      const isHidden = hiddenVariantIds.includes(String(event.detail.variant.id));
      if (!isHidden) {
        validateOptionCount();
        return;
      }

      const hiddenVariant = productVariants.find((variant) => variant.id === selectedVariant.id);
      if (!hiddenVariant) {
        validateOptionCount();
        return;
      }

      const disabledAndCheckedSize = sizeRadios.find(disabledAndCheckedRadio);
      if (disabledAndCheckedSize) {
        const firstVisibleRadio = sizeRadios.find((radio) => !radio.checked && !radio.classList.contains('disabled'));
        if (firstVisibleRadio) {
          disabledAndCheckedSize.checked = false;
          firstVisibleRadio.click();
        }
      }

      const disabledAndCheckedColor = colorRadios.find(disabledAndCheckedRadio);
      if (disabledAndCheckedColor) {
        const firstVisibleRadio = colorRadios.find((radio) => !radio.checked && !radio.classList.contains('disabled'));
        if (firstVisibleRadio) {
          disabledAndCheckedColor.checked = false;
          firstVisibleRadio.click();
        }
      }

      validateOptionCount();
    };

    window.addEventListener('variant:change', validateSelectedVariant);

    const initialVariant = data.initial_variant;
    if (initialVariant) validateSelectedVariant({ detail: { variant: initialVariant } });
  });
  } catch(e) { console.error(e); }
})();

})();
